import { render, staticRenderFns } from "./gameToolBackView.vue?vue&type=template&id=d5aa76bc&"
import script from "./gameToolBackView.vue?vue&type=script&lang=js&"
export * from "./gameToolBackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports